export const validation = {
  name_es: 'required|min:3|max:255',
  name_en: 'min:3|max:255',
  status_id: 'required|min_value:1|numeric|max_value:9'
}

export const typeFields = function () {
  return {
    name_es: null,
    name_en: null,
    status_id: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]

export const texts = {
  attributeTypeEdit: {
    title: 'Editar Tipo Existente',
    subtitle: 'Edita la información del tipo de atributo de producto.',
    submit: 'Actualizar Tipo',
    messages: {
      success: {
        title: 'TIPO ACTUALIZADO',
        text: 'Este tipo de attributo ha sido actualizado correctamente'
      }
    }
  },
  attributeTypeNew: {
    title: 'Añadir Nuevo tipo',
    subtitle: 'Crear nuevo tipo de atributo de producto',
    submit: 'Crear Tipo',
    messages: {
      success: {
        title: 'TIPO CREADO',
        text: 'Se ha creado correctamente el nuevo tipo de attributo de producto'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/products/attributes/type.mocks.js